import { Controller } from "@hotwired/stimulus";

// Rendered only when Reopen on a locked matrix redirected here, so it opens straight away.
export default class extends Controller {
  connect() {
    // Vue mounts over #vue-app after this first connects and re-creates the dialog with
    // `open` already set, which makes showModal() throw; reset it to get the modal backdrop.
    if (this.element.open) this.element.close();
    this.element.showModal();
  }

  close() {
    this.element.close();
  }
}
